
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bridge-wrap-ageth",
      function () {
        return require("private-next-pages/bridge-wrap-ageth.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bridge-wrap-ageth"])
      });
    }
  